import { cn } from "@/lib/utils";
import { type ReactNode } from "react";

type CompanyActivityBoxProps = {
  title: string;
  /** Badge next to the title (the kind of business). */
  badge?: ReactNode;
  children: ReactNode;
  className?: string;
};

/** Bordered "Activity" block of the panel header: title, badge, then the text. */
export default function CompanyActivityBox({
  title,
  badge,
  children,
  className,
}: CompanyActivityBoxProps) {
  return (
    <div
      className={cn(
        "mt-4 rounded-xl border border-border bg-background/80 p-3",
        className,
      )}
    >
      <div className="flex flex-col space-y-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            {title}
          </h3>
          {badge}
        </div>
        {children}
      </div>
    </div>
  );
}
